import { queryOptions } from '@tanstack/react-query';

import { fetchMarketEvents } from './marketEvents.api';

export const marketEventsOptions = {
  all: () => ['morning-intel', 'market-events'] as const,

  list: () =>
    queryOptions({
      queryKey: marketEventsOptions.all(),
      queryFn: fetchMarketEvents
    })
};
